<template>
  <div class="add-new-client">
    <md-dialog :md-active.sync="deleteDialog">
      <md-dialog-title>
        <span>Delete brand</span>
        <button class="btn btn--close" @click="deleteDialog = false; showDialog = true"></button>
      </md-dialog-title>
      <div class="margin-auto">
        <span>Are you sure you want to delete the next:</span>
        <div class="textTitle margin-medium--top">
          <span class="textTitleGrey--delete">{{ brand.client.name }}</span>
          <span class="textTitleGrey--delete" style="margin: 0 0.5ch;">/</span>
          <span class="textTitlesilver">{{ brand.name }}</span>
        </div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item row">
            <md-button class="md-primary modal-cancel-btn" @click="cancel; showDialog = true; deleteDialog = false">
              Cancel
            </md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn" @click="deleteBrand">Delete</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showDialog">
      <validation-observer v-slot="{ handleSubmit }" tag="div">
        <form @submit.prevent="handleSubmit(saveBrand)" class="form">
          <md-dialog-title v-if="!title">
            <span>Edit Brand for {{ client.name }}</span>
            <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <md-dialog-title v-if="title">
            <span>Edit Brand for {{ client.name }}</span>
            <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <div v-if="brandToEdit" class="form__content">
            <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
              <md-field>
                <label>Brand name</label>
                <md-input v-model="brandToEdit.name"/>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
            <md-field>
              <label>Brand logo</label>
              <!-- <md-file
                  v-model="fileNamesToUpload"
                  v-on:change="filesSelected"
                  accept="image/*"/> -->
              <div class="md-file">
                <input readonly="readonly" class="md-input" v-model="fileNamesToUpload"/>
                <input type="file" accept="image/*" @change="filesSelected"/>
              </div>
            </md-field>
            <!-- <img v-if="brandToEdit.logo" :srcset="brandToEdit.logo.srcset" style="width: 150px;"> -->
          </div>
          <md-dialog-actions>
            <div class="md-layout">
              <div class="md-layout-item row">
                <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                <a class="hrefButton--black margin-medium--left" @click="deleteDialog = true; showDialog = false">Delete
                  Brand</a>
              </div>
              <div class="md-layout-item text-right">
                <md-button class="md-primary modal-save-btn" type="submit">Save Brand</md-button>
              </div>
            </div>
          </md-dialog-actions>
        </form>
      </validation-observer>
    </md-dialog>

    <div class='buttonContainer'>
      <button class="btn" :class="{'btn-icon': !title, 'btn-edit': title}"
              @click="showDialog = true; brandToEdit = {...brand}; fileNamesToUpload = brand.logo.file_name_original">
        <img alt="edit" class="editButton" src="@/assets/img/icons/edit.svg"/>
        {{ title }}
      </button>
    </div>
  </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {min, required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "Brand name is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  mixins: [apiHandlerMI],
  props: ['client', 'brand', 'title'],
  data() {
    return {
      showDialog: false,
      deleteDialog: false,
      active: false,
      error: [],
      needUpload: false,
      type: 'square',
      filesToUpload: null,
      fileNamesToUpload: undefined,
      brandToEdit: undefined
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    deleteBrand() {
      const _this = this;
      this.delete(`brand/${this.brand.id}`, {}, () => {
        _this.showDialog = false;
        _this.deleteDialog = false;
        _this.$router.push({name:'Client', params:{client_slug: _this.brand.client.slug}});
      }, () => {
        console.log('Sikertelen Torles');
      });
    },
    filesSelected(event) {
      this.needUpload = true;
      this.client.logo = undefined; //?? brand.logo 
      this.filesToUpload = event.target.files;
      this.fileNamesToUpload = this.filesToUpload[0].name
    },
    upload_selected: function (num = 0) {
      if (!this.needUpload)
        return false;
      const _this = this;
      if (!(this.filesToUpload || []).length) {

        this.error.logo = "Image required!";
        this.$forceUpdate();
        return;
      }
      if (!this.type) {
        this.error.logo = "Type required!";
        this.$forceUpdate();
        return;
      }
      this.error.logo = undefined;
      if (this.filesToUpload.length <= num) {
        this.fileNamesToUpload = undefined;
        //this.uploadSuccess = `You have successfully uploaded ${num} files`;
        setTimeout(() => {
          _this.uploadSuccess = undefined;
        }, 3000);
        return;
      }

      let file = this.filesToUpload[num];

      const formData = new FormData();
      formData.append("files[0]", file);
      formData.append("payment_cluster_id", this.brand.payment_cluster_id);
      formData.append("folder", 'brands');
      formData.append("upload_type", this.type);

      var url = "image";
      if (this.filesToUpload[num].type == "application/pdf") url = "document";
      //console.log("start_upload");
      this.post(
          "filemanager/upload/" + url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function (resp) {
            _this.needUpload = false;
            _this.brandToEdit.logo = resp.data.images[0].id
            _this.saveBrandData();
            //_this.upload_selected(num + 1);
          }
      );
    },
    saveBrand() {
      if (this.needUpload)
        this.upload_selected();
      else {
        this.saveBrandData()
      }
    },
    saveBrandData() {
      var _this = this;
      const savebrand = this.brandToEdit

      savebrand.client_id = this.client.id; //?? 
      if (savebrand.logo.id)
      savebrand.logo = savebrand.logo.id;

      this.put('brand/' + savebrand.id, savebrand, 
      {}, 
      function () {
        //console.log(resp.data);        
        if (_this.$parent.refreshBrand)           
          _this.$parent.refreshBrand()

        //for editBrand component on groupTablescomponent
        if (_this.$parent.setRefreshClient)           
          _this.$parent.setRefreshClient()
        
        _this.showDialog = false

      }, function (resp) {
        //console.log(resp);
        _this.error = resp.data.error;
        _this.showDialog = true
        this.$forceUpdate();
      })
    },
    cancel() {
      this.showDialog = false

    }
  }
}

</script>